import React from 'react';
import { Helmet } from 'react-helmet-async';

const siteUrl = process.env.REACT_APP_SITE_URL || 'https://your-domain.vercel.app';

interface StructuredDataProps {
  type?: 'home' | 'page';
  breadcrumbs?: Array<{ name: string; url: string }>;
}

export const StructuredData: React.FC<StructuredDataProps> = ({ type = 'home', breadcrumbs }) => {
  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Antonio Michal Verdile',
    jobTitle: 'Software Engineer',
    url: siteUrl,
    sameAs: [
      'https://github.com/MichalVerdile',
      'https://linkedin.com/in/antonio-verdile'
    ],
    knowsAbout: [
      'Software Engineering',
      'Full Stack Development',
      'React',
      'TypeScript',
      'C#',
      '.NET',
      'Web Development',
      'JavaScript',
      'Python',
      'Machine Learning',
      'Quantum Computing'
    ],
    alumniOf: [
      {
        '@type': 'EducationalOrganization',
        name: 'ZHAW Zurich University of Applied Sciences'
      },
      {
        '@type': 'EducationalOrganization',
        name: 'Alte Kantonsschule Aarau'
      }
    ],
    worksFor: {
      '@type': 'Organization',
      name: 'ALIAS ZHAW Student Association'
    }
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Antonio Michal Verdile - Portfolio',
    url: siteUrl
  };

  const breadcrumbSchema = breadcrumbs ? {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url
    }))
  } : null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(personSchema)}
      </script>
      {type === 'home' && (
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
      )}
      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
    </Helmet>
  );
};
